<template>
  <div class="">
    <form @submit.prevent="onSubmit">


      <h5 class="mb-3">افزایش اعتبار:
        {{ subscriptionCharge.user.name }} {{ subscriptionCharge.user.last_name }}
      </h5>

      <form-group class="col-lg-12 col-md-6 mb-3 text-right Font" :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }">
          <label for="">شناسه اشتراک</label>

          <b-form-input
              id="input-1"
              type="text"
              v-model="form.name"
          ></b-form-input>


          <form-errors-manager :errors="errors"/>
        </div>

      </form-group>


      <form-group class="col-lg-12 col-md-6 mb-3 text-right Font" :validations="$v.form.value">
        <div slot-scope="{ errors, invalid }">
          <label for="">اعتبار</label>

          <template v-if="subscriptionCharge.subscription.value_type =='number'">
            <b-form-input
                id="input-1"
                type="number"
                v-model="form.value"
            ></b-form-input>
          </template>

          <template v-else>
            <date-picker auto-submit v-model="form.value"
                         placeholder="تاریخ را انتخاب کنید."
                         class="text-left"
                         type="datetime"
                         format="YYYY-MM-DD HH:mm:ss" display-format="jYYYY/jM/jD HH:mm:ss"/>
          </template>

          <form-errors-manager :errors="errors"/>
        </div>

      </form-group>

      <form-group class="col-lg-12 col-md-6 mb-3 text-right Font" :validations="$v.form.description">
        <div slot-scope="{ errors, invalid }">
          <label for="">توضیحات</label>

          <b-textarea v-model="form.description"/>

          <form-errors-manager :errors="errors"/>
        </div>

      </form-group>


      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary col-3 rounded-pill my-3">ثبت</button>
      </div>

    </form>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {required, integer} from "vuelidate/lib/validators";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "ChargeSubscription",
  components: {datePicker: VuePersianDatetimePicker, FormGroup, FormErrorsManager},
  props: {
    subscriptionCharge: {}
  },
  data() {
    return {
      form: {
        value: null,
        description: null,
        name: ""
      }
    }
  },
  validations: {
    form: {
      value: {required},
      description: {},
      name: {required},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {


        let form = {
          subscription_charge_id: this.subscriptionCharge.id,
          value: this.form.value,
          name: this.form.name,
          description: this.form.description,
        }

        let req = this.$store.dispatch('SubscriptionCharge/chargeSubscription', form)
        req.then(res => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
          this.$emit('reloadItems')
        })
      }

    }
  },
  mounted() {
    this.form.value = this.subscriptionCharge.value
    this.form.description = this.subscriptionCharge.description
    this.form.name = this.subscriptionCharge.name
  }
}
</script>

<style scoped>

</style>